module.exports = __webpack_public_path__ + "static/media/video_c.21d9303f.mp4";